// extracted by mini-css-extract-plugin
export default {"image":"XW-z","loaded":"YW-z"};